/**
 * @generated SignedSource<<b3c7e986edd6b6c02d9f342532089a74>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedVideoComponent_componentModule$data = {
  readonly userType: string | null;
  readonly videoId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedVideoComponentCarousel_componentModule" | "HpSharedVideoComponentTitle_componentModule" | "HpSharedVideoComponentVideo_componentModule">;
  readonly " $fragmentType": "HpSharedVideoComponent_componentModule";
};
export type HpSharedVideoComponent_componentModule$key = {
  readonly " $data"?: HpSharedVideoComponent_componentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedVideoComponent_componentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedVideoComponent_componentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "videoId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedVideoComponentTitle_componentModule"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedVideoComponentVideo_componentModule"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedVideoComponentCarousel_componentModule"
    }
  ],
  "type": "VideoModule",
  "abstractKey": null
};

(node as any).hash = "eec1161a06683328db09ea52975664ac";

export default node;
